// src/components/sections/ConfigCard.js

import React from 'react';
import { Check, AlertCircle } from 'lucide-react';

const ConfigCard = ({ icon: Icon, title, children, className = '' }) => (
  <div className={`bg-white rounded-xl border border-gray-100 shadow-sm p-6 ${className}`}>
    <div className="flex items-center space-x-3 mb-4">
      <div className="p-2 rounded-lg bg-violet-50">
        <Icon className="w-5 h-5 text-violet-600" />
      </div>
      <h3 className="text-lg font-semibold">{title}</h3>
    </div>
    {children}
  </div>
);

export default ConfigCard;
